import { MagnifyingGlass } from "@phosphor-icons/react";
import { openPrybar } from "./spark";

const isMac = typeof navigator !== "undefined" && /Mac|iPhone|iPad|iPod/.test(navigator.platform);

export function HealthOsCommandTrigger() {
  return (
    <button
      type="button"
      onClick={openPrybar}
      aria-label="Open command bar"
      title={`Search or ask HealthOS (${isMac ? "⌘K" : "Ctrl K"})`}
      className="group flex w-full items-center gap-2.5 rounded-md border border-border-card bg-surface-elevated px-2.5 py-2 text-left text-ink-tertiary transition-colors hover:bg-surface-track focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-500"
    >
      <MagnifyingGlass
        size={16}
        weight="regular"
        className="shrink-0 text-ink-quaternary transition-colors group-hover:text-ink-brand-light"
      />
      <span className="min-w-0 flex-1 truncate text-sm tracking-[-0.005em]">Search or ask…</span>
      <kbd className="hidden shrink-0 rounded-sm border border-border-card bg-surface-track/60 px-1.5 py-0.5 font-mono text-xs text-ink-tertiary group-hover:text-ink-secondary sm:inline">
        {isMac ? "⌘K" : "Ctrl K"}
      </kbd>
    </button>
  );
}
